import { useAppTheme } from "../hooks/useAppTheme";

export function ThemeAppearance() {
  const { preference, setPreference } = useAppTheme();
  return <fieldset className="pc-theme-choice">
    <legend>Tema do aplicativo</legend>
    <p>Escolha o visual mais confortável para você.</p>
    <div className="pc-theme-options">
      {[
        { value: "light", title: "Claro", icon: "☀", description: "Leve e luminoso" },
        { value: "dark", title: "Escuro", icon: "☾", description: "Suave à noite" },
        { value: "system", title: "Automático", icon: "◐", description: "Igual ao dispositivo" },
      ].map(option => <label key={option.value} className={`pc-theme-option pc-theme-option--${option.value}`}>
        <input type="radio" name="app-theme" value={option.value} checked={preference === option.value} onChange={() => setPreference(option.value)} />
        <span className="pc-theme-swatch" aria-hidden="true"><span>{option.icon}</span><i /><i /></span>
        <span className="pc-theme-option-title">{option.title}<span aria-hidden="true">{preference === option.value ? "✓" : ""}</span></span>
        <small>{option.description}</small>
      </label>)}
    </div>
    <small>A mudança é imediata e fica salva neste dispositivo.</small>
  </fieldset>;
}
